/**
 * @module module:components/shared
 * Requires all the shared components into one place to do bulk imports more nicely
 */
import { Backspace } from './backspace/main';
import { Button } from './button/main';
import { Card } from './card/main';
import { Container } from './container/main';
import { Dropdown } from './dropdown/main';
import { Header } from './header/main';
import { Input } from './input/main';
import { Logo } from './logo/main';
import { Modal } from './modals/main';
import { Messagebar } from './messagebar/main';
import { Progressbar } from './progressbar/main';
import { ShiftCard } from './shiftcard/main';
import SystemMessages from './systemmessage/main';
import { Textarea } from './textarea/main';
import { Checkbox } from './checkbox/main';
import { Tick } from './tick/main';
import IpadStandard from './ipad-standard';
import Laptop from './laptop';
import Clockin from './clockin';

export {
  Backspace,
  Button,
  Card,
  Container,
  Dropdown,
  Header,
  Input,
  Logo,
  Messagebar,
  Modal,
  Progressbar,
  ShiftCard,
  SystemMessages,
  Textarea,
  Checkbox,
  Tick,
  IpadStandard,
  Laptop,
  Clockin,
};



// WEBPACK FOOTER //
// ./src/components/shared/index.js